import { CardConfiguration } from './card-configuration';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { PreviewCertificate, Certificate } from 'app/core/components/content/certificate/certificate';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';

declare var moment: any;


export class ClassCardConfiguration extends CardConfiguration {
    constructor(course: any, certificateService: CertificateService) {
        super();
        let hoursSinceRelease = moment.duration(moment().diff(moment(course.releaseDate, "YYYY.MM.DD HH:mm").toDate())).asHours();
        this.tagType = 'class';
        this.classType = (hoursSinceRelease <= 72 && !course.expired) ? 'New Class' : 'Class';
        this.thumbnail = course.virtualVenue ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/classroom-class.png' :
            'https://itpx-branded-portal-dev.s3.amazonaws.com/online-class.png';
        this.expired = course.expired;
        this.clickable = true;  //Always true since available till is on assignment lvl, this is classEvent lvl
        this.target = ['/app', 'class', course.id];
        this.hideInstructor = true;
        this.action = LinkActions.REDIRECT;
        this.hideLocation = true;
        this.links = [{
            disabled: false, tooltip: null,
            type: LinkActions.REDIRECT,
            url: this.clickable ? this.target : [],
            text: 'branded.portal.courses.class.material.text'
        }];
        // Disable for now download link for participation certificates
        if (course.participationCertificateStatus && course.participationCertificateStatus !== 'STOP') {
            this.links.push({
                type: LinkActions.ACTION,
                action: (_) => certificateService.getCertificateDownloadLink(new PreviewCertificate(new Certificate([course.participationCertificate])))
                    .switchMap(res => certificateService.getCertificateFile(res.data.certLocation, course.participationCertificate.displayName)),
                disabled: !course.participationCertificate || course.participationCertificateStatus !== 'SENT',
                tooltip: course.participationCertificate && course.participationCertificateStatus === 'SENT' ? null
                    : 'branded.portal.courses.participation.certificate.link',
                url: [],
                text: 'branded.portal.courses.participation.certificate.text',
                image: course.participationCertificate && course.participationCertificateStatus === 'SENT' ?
                    'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate.svg' :
                    'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate-inactive.svg'
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/class-card-configuration.ts